import { constants } from '@clearscore/redux.market';

import messagesGB from './locale/en-gb/messages.json';
import messagesIN from './locale/hi-in/messages.json';

const { EN_GB, HI_IN } = constants;

export default {
    [EN_GB]: {
        messages: messagesGB,
    },
    [HI_IN]: {
        messages: messagesIN,
    },
};
